/**
 * Tutor modes and the live session meter.
 *
 * Owner (DEV 2026-09-24): two modes the learner can talk or type in - Voice (the tutor speaks) and
 * Chat (the tutor writes; "Text" until owner 2026-09-29) - items 5 and 9; talk mode sat on "Connecting..." (item 8); an exhausted
 * allowance must stop the tutor mid-way with a clear message (item 11). Sol owner14 Q2 and
 * owner14-e (A): the worker extends the session and sends what is left on topic quiklearn-meter.
 */
export const METER_TOPIC = 'quiklearn-meter';

/** "Chat": type or speak, the tutor replies in writing. The backend bills it to the Chat (text) meter. */
export const TEXT_MODE = 'HYBRID';

export const writesReplies = mode => mode === 'TEXT' || mode === 'HYBRID';
export const listensToLearner = mode => mode === 'VOICE' || mode === 'HYBRID';

const decode = payload => {
  if (typeof payload === 'string') return payload;
  try {
    return new TextDecoder().decode(payload);
  } catch (_) {
    return '';
  }
};

/** {type: 'meter', secondsLeft} or {type: 'ended', ...}; null for anything else. */
export const parseMeterMessage = payload => {
  let data;
  try {
    data = JSON.parse(decode(payload));
  } catch (_) {
    return null;
  }
  if (data?.type === 'meter' && Number.isFinite(data.secondsLeft)) return data;
  if (data?.type === 'ended') return data;
  return null;
};

export const minutesLeftLabel = seconds => {
  if (!Number.isFinite(seconds)) return null;
  if (seconds < 60) return 'Less than a minute left';
  return `${Math.floor(seconds / 60)} min left`;
};

/**
 * What a session end opens (owner 2026-09-29): a used-up meter opens the full-screen plans, with the
 * other mode's minutes so they can offer "Use Chat instead"; a session that simply ended is not a
 * limit and shows only a quiet "Session ended · Start again" line.
 */
export const sessionEndNotice = ended => {
  const reason = ended?.reason || 'SESSION_ENDED';
  const meter = ended?.meter === 'voice' ? 'voice' : 'text';
  if (reason === 'QUOTA_EXHAUSTED' || reason === 'NO_SUBSCRIPTION') {
    const other = Number(ended?.otherSecondsLeft);
    return {
      kind: 'quota',
      meter,
      otherMeter: ended?.otherMeter === 'voice' ? 'voice' : ended?.otherMeter ? 'text' : null,
      otherSecondsLeft: Number.isFinite(other) ? other : 0,
      resetAt: ended?.resetAt || null,
    };
  }
  return {kind: 'ended', meter};
};
